import { render, staticRenderFns } from "./Extraunit.vue?vue&type=template&id=5825129c&scoped=true"
import script from "./Extraunit.vue?vue&type=script&lang=js"
export * from "./Extraunit.vue?vue&type=script&lang=js"
import style0 from "./Extraunit.vue?vue&type=style&index=0&id=5825129c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5825129c",
  null
  
)

export default component.exports